import { API } from "../network/API";
import { VALIDATION_STATE } from "../hooks/useValidation";
import { BaseValidator } from "./BaseValidator";
export class EmailValidator extends BaseValidator {
    constructor() {
        super(...arguments);
        this.name = "EmailValidator";
    }
    getId() {
        return this.getBaseId();
    }
    validate(email) {
        if (email.length === 0) {
            return Promise.resolve({
                status: VALIDATION_STATE.SUCCESS,
                hideError: true,
            });
        }
        if (!/^[^@]+@[^@]+\.[^.]+$/.test(email)) {
            return Promise.resolve({
                status: VALIDATION_STATE.FAILED,
                message: this.error,
                hideError: !email.includes("@"),
            });
        }
        return new Promise((resolve, reject) => {
            API.post(`/validation`, { email })
                .then((response) => {
                if (response.valid) {
                    resolve({ status: VALIDATION_STATE.SUCCESS });
                }
                else {
                    resolve({
                        status: VALIDATION_STATE.FAILED,
                        message: this.error,
                        hideError: !email.includes("@"),
                    });
                }
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
}
